import { RG_TYPE } from "@project-rouge/rg-core";
function getCoreCost(state, props) {
	if (props.skipCores) return 0;
	return state.sequence.filter((u) => u.unit.type === RG_TYPE.Core).length * props.dataset.aggConfig.maxTravelDistBidirectional * 2 / state.totalLength;
}
export { getCoreCost };

//# sourceMappingURL=index139.js.map